/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, SCS) {
	'use strict';
	// Note: For the Responsive Header
	//	- DON'T use:	.is-mobile		(server has detected a mobile device, mobile.jsp is rendered)
	//	- OK to use:	.scsh-mobile	(client has detected a small screen size)
	//		- but of course it's better to move mobile-only stuff into the MobileMenu skin

	var KEYS = {
		ESCAPE: 27,
		DOWN: 40,
		UP: 38,
		ENTER: 13
	};

	var LIVE_SEARCH_RESULTS = 3;

	function stop(event) {
		event.preventDefault();
	}

	function trackLiveSearchClick(mod, liveSearch) {
		Module.SearchResultContainer.trackClick('ac', mod.liveSearchConfig, liveSearch, mod.liveSearchProcessor);
	}

	var TEXT_SIZING_ATTEMPTS = 50;
	var CLEAR_ICON_DISTANCE_TO_TEXT = 8;
	var APPROX_LETTER_WIDTH = 16;
	var WANTED_FONT_DEFINITION = 'normal 32px TheSerifB3';
	var PROCESS_WAIT_TIMEOUT = 200;

	function calcTextWidth(field) {
		if(!field.length || !window.getComputedStyle) {
			return field.length ? field.val().length * APPROX_LETTER_WIDTH : 0;
		}
		var text = field.val();
		var font = window.getComputedStyle(field[0], null).getPropertyValue('font') || WANTED_FONT_DEFINITION;
		var $fakeEl = $($('<pre>').hide().appendTo(document.body));
		$fakeEl.text(text);
		$fakeEl.css('font', font);
		var wRet = $fakeEl.width();
		$fakeEl.detach();
		return wRet;
	}

	/**
	 * SiteSearch module implementation.
	 *
	 * @author Cesar Keller & Raphael Schweikert & Benjamin Berger
	 * @namespace Tc.Module
	 * @class SiteSearch
	 * @extends Tc.Module
	 */
	Module.SiteSearch = Module.extend({
		// The array of search suggestions
		suggestions: [],
		// The array of keymatches for the current suggestions
		keymatches: [],
		// URLs of all last-recently loaded keymatches (for deduplication)
		keymatchURLs: {},
		// The array of live search results
		liveSearches: [],
		// Concatenation of all results (suggestions and keymatches combined)
		// for the purpose of making selection tracking and arrow key handling simpler.
		results: [],
		// The result that is currently selected. May be a suggestion or a keymatch.
		selectedIndex: -1,

		// Value of the field at the time the last query was made
		// (to revert after selecting keymatches)
		prevFieldVal: '',

		on: function (callback) {
			var mod = this;

			// FIXME: Can’t we move most of these to “after”?
			mod.findElements();
			mod.addEventHandlers();

			mod.textCalculationLoopCounter = 0;

			callback();
		},

		after: function() {
			var mod = this;
			mod.initSearchProcessor();
			mod.initLiveSearchProcessor();
		},

		initSearchProcessor: function() {
			var mod = this;
			mod.searchProcessor = SCS.search.orchestration.forAutosuggest(
				mod.$container.data('gsahostname'),
				mod.$container.data('gsasites'),
				mod.$container.data('gsaclient'),
				mod.$container.data('gsanumberofresults'),
				mod.$container.data('gsainstantsearchresults'),
				$('html').attr('lang') || 'de',
				mod.$container.data('instantsearchcollectionsuffix')
			);
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				'data': mod.suggestData,
				'keymatch-data': mod.keymatchData
			}, mod));
		},

		initLiveSearchProcessor: function() {
			var mod = this;
			mod.liveSearchProcessor = SCS.search.orchestration.forSerp(
				mod.$container.data('gsahostname'),
				mod.$container.data('gsasites'),
				mod.$container.data('gsaclient'),
				$('html').attr('lang') || 'de',
				{
					// Take deduplication into account and load more live search results than would be needed
					// in case all keymatches appear in the results
					resultLimit: LIVE_SEARCH_RESULTS + mod.$container.data('gsainstantsearchresults'),
					origin: 'header'
				}
			);
			mod.liveSearchProcessor.responder(SCS.search.util.respondTo({
				data: mod.liveSearchData
			}, mod));
		},

		findElements: function() {
			var mod = this,
				$ctx = mod.$ctx;

			var $container = mod.$container = $ctx.find('.scsh-sitesearch-container');
			mod.$field = mod.$container.find('input.scs-sitesearch-searchfield-input');
			mod.$instantResultContainer = $container.find('.scsh-instant-result-container');
			mod.$submitButton = $ctx.find('.scsh-sitesearch-submit-button');
			mod.$form = $ctx.find('.scsh-sitesearch-form');

			mod.suggestResultContent = $container.find('.scsh-autosuggest-content')[0];
			mod.keymatchResultContent = $container.find('.scsh-keymatch-content')[0];
			mod.liveSearchContent = $container.find('.scsh-livesearch-content')[0];

			mod.$whiteOut = $('.scsh-modSiteSearch-white-out');
			if(!mod.$whiteOut.length) {
				if(SCS.utils.isMobilePage()) {
					mod.$whiteOut = $('<div class="scsh-modSiteSearch-white-out"></div>').appendTo(mod.$ctx);
				} else {
					mod.$whiteOut = $('<div class="scsh-modSiteSearch-white-out"></div>').appendTo([
						document.body,
						mod.$ctx.closest('.modHeader').find('>.scsh-dynamic')
					]);
				}
			}
			mod.$delEl = mod.$ctx.find('.scsh-sitesearch-del-content');

			// make dev life easier
			if (location.search.match(/\bwcmmode=disabled\b/)) {
				if (mod.$form.prop('action') && !mod.$form.prop('action').match(/\bwcmmode=disabled\b/)) {
					mod.$form.prop('action', mod.$form.prop('action') + location.search);
				}
			}
		},

		// Called when the *displayed* query needs to be updated (without triggering anything)
		updateQuery: function(query) {
			var mod = this;
			var prevValue = mod.$field.val();
			if(prevValue === query) {
				return;
			}
			mod.$field.val(query);
			mod.activateDelContentButton();
			mod.checkForEmptyContent();
		},

		activateSearchField: function() {
			this.$field.focus();
		},

		// Overridden in MobileMenu skin
		checkAndCalcTextWidth: function(field) {
			var mod = this;
			if(mod.textCalculationLoopHandle) {
				window.clearTimeout(mod.textCalculationLoopHandle);
				mod.textCalculationLoopHandle = null;
			}
			function setCalculatedWidth() {
				var calcedWidth = calcTextWidth(field);
				if(calcedWidth) {
					// Fix Safari rendering this element too close
					if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
						calcedWidth += 10;
					}

					mod.$delEl.css('left', (calcedWidth + CLEAR_ICON_DISTANCE_TO_TEXT) + 'px').show();
				} else {
					mod.$delEl.hide();
				}
			}
			if(!document.fonts) {
				setTimeout(function() {
					setCalculatedWidth();
				}, 1);
			} else if(!document.fonts.check(WANTED_FONT_DEFINITION) && mod.textCalculationLoopCounter < TEXT_SIZING_ATTEMPTS) {
				mod.textCalculationLoopHandle = setTimeout(function() {
					mod.textCalculationLoopHandle = null;
					mod.textCalculationLoopCounter += 1;
					mod.checkAndCalcTextWidth(field);
				}, 100);
			} else {
				setCalculatedWidth();
			}
		},

		activateDelContentButton: function () {
			var mod = this;
			mod.$delEl.toggleClass('active', !!mod.$field.val());
			mod.checkAndCalcTextWidth(mod.$field);
		},

		checkForEmptyContent: function () {
			var mod = this;
			var fieldVal = mod.$field.val();
			if (fieldVal && fieldVal.length) {
				mod.$submitButton.addClass('active');
			} else {
				mod.$submitButton.removeClass('active');
			}
		},

		addEventHandlers: function () {
			// FIXME: Break this method up into smaller pieces, maybe create mobile skin and add overloads for mobile-only stuff there
			var mod = this,
				$ctx = mod.$ctx,
				$form = mod.$form,
				$field = mod.$field,
				$button = $ctx.find('.scsh-sitesearch-open-button'),
				isOpen = false;

			$field.on('focus', function () {
				$ctx.addClass('active');
				mod.$container.addClass('scsh-focus');
				mod.$whiteOut.show();
				isOpen = true;
				mod.checkForEmptyContent();
				mod.$delEl.removeClass('active');
			});

			// custom event fired by scsSiteSearch.Serp.init()
			$(document).on('scsSiteSearch-serp-query', function (event, q) {
				// we are on a search result page (SERP)
				isOpen = !!q;
				mod.updateQuery(q);
				$ctx.addClass('scsh-search-result-page active');
			});

			$field.on('blur', function () {
				mod.$whiteOut.hide();
				var fieldVal = $field.val();
				if (fieldVal && fieldVal.length) {
					mod.activateDelContentButton();
				}
				mod.$container.removeClass('scsh-focus');
			});

			function close() {
				$ctx.removeClass('active');
				isOpen = false;
			}
			$field.on('keydown', function (event) {
				mod.$delEl.removeClass('active');
				// Escape
				if (event.which === KEYS.ESCAPE) {
					$field.blur();
					close();
				}
			});

			$field.on('keyup', function() {
				mod.checkForEmptyContent();
			});

			$field.on('keydown', function(event) {
				var selectedKeymatch = mod.getSelectedKeymatch();
				if(event.keyCode === KEYS.UP) {
					mod.selectionChanged(-1);
				} else if(event.keyCode === KEYS.DOWN) {
					mod.selectionChanged(+1);
				} else if(event.keyCode === KEYS.ENTER && selectedKeymatch) {
					event.stopPropagation();
					event.preventDefault();
					mod.activateKeymatch(selectedKeymatch);
					// Open the keymatch. We could also synthesize a click on the element… Which is better?
					if (window.top && window.top !== window) {
						window.top.location = selectedKeymatch.url;
					} else {
						window.location = selectedKeymatch.url;
					}
				} else {
					return;
				}
				// Do not further process the key press:
				// * Do not trigger a new search
				// * Do not move the cursor the beginning or end when navigating suggestions or keymatches
				event.stopImmediatePropagation();
				return false;
			});
			var processKeyPressTimeout = null;
			$field.on('input keypress', function(event) {
				if(event.which === KEYS.ENTER) {
					// Selected suggestions already updated the field value with the suggestion
					// and normal searches can just trigger the regular form submit
					return;
				}
				var value = $field.val();
				if(value === mod.prevFieldVal) {
					return;
				}

				mod.prevFieldVal = value;

				clearTimeout(processKeyPressTimeout);
				processKeyPressTimeout = setTimeout(function() {
					processKeyPressTimeout = null;
					mod.searchProcessor.process({query: value});
				}, PROCESS_WAIT_TIMEOUT);
			});
			$button.on('click', function () {
				mod.log('open clicked', isOpen);
				if (!isOpen) {
					$field.focus();
				} else {
					close();
				}
			});
			$ctx.find('.scsh-sitesearch-close-button').on('click', close);
			mod.$submitButton.on('click', function () {
				if (mod.$submitButton.hasClass('active')) {
					$form.submit();
					mod.$submitButton.removeClass('active');
					mod.activateDelContentButton();
				}
			});
			$form.on('submit', function(event) {
				event.preventDefault();
				var target = $form.attr('action');
				var pivot = '#'; // RESOLVE: Do we need to use query params at one point or is the hash always ok?
				var separator = target.indexOf(pivot) > -1 ? '&' : pivot;
				var query = {q: $field.val()};
				target = target + separator + SCS.search.util.param(query);
				// FIXME: Should we also send an event so the SearchResultContainer module does not need to rely on the hashchange event if on a SERP?
				window.location.href = target;
				$field.blur();
			});

			var touched = false;
			mod.$delEl.on('click', function(event) {
				if(event.type === 'touchstart') {
					touched = true;
				} else if(touched) {
					// Don’t act on both “click” and “touchstart”
					touched = false;
					return;
				}
				mod.clearSearchField();
				mod.activateSearchField();
			});
		},

		clearSearchField : function() {
			this.$field.val('');
		},

		updateDom: function() {
			this.updateSuggestions();
			this.updateKeymatches();
			this.updateLiveSearch();
			this.updateSelection();
			this.triggerLiveSearch();
		},

		getSelectedSuggestion: function() {
			var mod = this;
			if(mod.selectedIndex in mod.suggestions) {
				return mod.suggestions[mod.selectedIndex];
			}
			return null;
		},

		selectSuggestion: function(index) {
			this.selectedIndex = index;
			this.updateDom();
		},

		getSelectedKeymatch: function() {
			var mod = this;
			// Relies on the ordering of mod.results to always put suggestions before keymatches.
			var selectedKeymatchIndex = mod.selectedIndex - mod.suggestions.length;
			if(selectedKeymatchIndex in mod.keymatches) {
				return mod.keymatches[selectedKeymatchIndex];
			}
			return null;
		},

		selectKeymatch: function(index) {
			// Relies on the ordering of mod.results to always put suggestions before keymatches.
			this.selectedIndex = this.suggestions.length + index;
			this.updateDom();
		},

		updateSuggestions: function() {
			var mod = this;

			var selectedSuggestion = mod.getSelectedSuggestion();
			var results = mod.suggestions;
			var snabbdom = window.snabbdom;
			var h = snabbdom.h;
			var contents = [];
			for(var i=0;i<results.length;i+=1) {
				var result = results[i];
				contents.push(h(
					'li.scs-sitesearch-autosuggest-li',
					{
						'class': {
							'scs-sitesearch-searchfield-hoveractive': result === selectedSuggestion
						},
						on: {
							click: [$.proxy(mod.activateSuggestion, mod), result],
							// Don’t let the mousedown trigger a blur of the input field (otherwise we don’t get a click)
							mousedown: stop
						}
					},
					result.name
				));
			}
			var suggestions = h('ul.suggestions', contents);
			mod.suggestResultContent = snabbdom.patch(mod.suggestResultContent, suggestions);
			mod.$instantResultContainer.toggleClass('has-suggestions', !!results.length);
			mod.calculateAndSetContainerHeight();
		},

		updateKeymatches: function() {
			var mod = this;

			var selectedKeymatch = mod.getSelectedKeymatch();
			var results = mod.keymatches;
			var snabbdom = window.snabbdom;
			var h = snabbdom.h;
			var contents = [];
			for(var i=0;i<results.length;i+=1) {
				var result = results[i];
				var image;
				if(result.image) {
					image = h('img', {props: {src: result.image}});
				} else if(result.display === 'product') {
					image = h('div');
				} else {
					image = h('div.icon');
				}
				contents.push(h(
					'li.scs-sitesearch-keymatch-li.type-'+(result.display),
					{
						'class': {
							'scs-sitesearch-searchfield-hoveractive': result === selectedKeymatch
						}
					},
					[h(
						'a',
						{
							on: {
								click: [$.proxy(mod.activateKeymatch, mod), result],
								// Don’t let the mousedown trigger a blur of the input field (otherwise we don’t get a click)
								mousedown: stop
							},
							attrs: {
								href: result.url
							}
						},
						[
							h('div.image', {
								'class': {
									'type-iconfont': !result.image,
									'type-bitmap': !!result.image
								}
							}, [image]),
							h('div.text.scs-font-regular', [h('h4', result.title), h('p', result.subtitle)])
						]
					)]
				));
			}
			var keymatches = h('ul.keymatches', {}, contents);
			mod.keymatchResultContent = snabbdom.patch(mod.keymatchResultContent, keymatches);
			mod.$instantResultContainer.toggleClass('has-keymatches', !!results.length);
			mod.calculateAndSetContainerHeight();
		},

		calculateAndSetContainerHeight : function() {
			var mod = this;
			// calculate height of children and set it fixed for animation
			// problem why this is needed: setting it to a very height fixed number --> too fast animation
			// setting to a low fixed value --> Content is cut. Solution: dynamic fixed heigt, based on content
			var totalHeight = 0;
			mod.$instantResultContainer.children().each(function(){
			    totalHeight = totalHeight + $(this).outerHeight(true);
			});
			mod.$instantResultContainer.css('max-height', totalHeight + 'px');
		},

		updateLiveSearch: function() {
			var mod = this;

			var results = mod.liveSearches;
			var snabbdom = window.snabbdom;
			var h = snabbdom.h;
			var contents = [];
			for(var i=0;i<results.length && contents.length < LIVE_SEARCH_RESULTS;i+=1) {
				var liveSearch = results[i];
				// Deduplicate search results that already appear as keymatches
				if(Module.SearchResultDisplay.normalizeURL(liveSearch.url) in mod.keymatchURLs) {
					continue;
				}
				var liContent = [
					h(
						'a',
						{
							props: {
								href: liveSearch.url
							},
							on : {
								click: [trackLiveSearchClick, mod, liveSearch],
								mousedown: stop
							}
						},
						[Module.SearchResultContainer.unsafelyStripHTML(liveSearch.title)]
					),
					h('small.snippet', Module.SearchResultContainer.snippetToVDomElements(liveSearch.snippet, h))
				];

				// jshint camelcase: false
				if(liveSearch.meta && liveSearch.meta.search_image_url) {
					liContent.push(h('div.livesearch-icon', {},
						[h('img', {props: {src: liveSearch.meta.search_image_url}})]
					));
				}
				contents.push(h(
					'li.scs-sitesearch-livesearch-li',
					{
						'class': {
							'has-snippet': !!liveSearch.snippet
						}
					},
					liContent
				));
			}
			var liveSearches = h('ul.livesearch', {}, contents);
			mod.liveSearchContent = snabbdom.patch(mod.liveSearchContent, liveSearches);
			mod.$instantResultContainer.toggleClass('has-livesearches', !!results.length);
			mod.calculateAndSetContainerHeight();
		},

		updateSelection: function() {
			var mod = this;
			// If a keymatch or nothing was selected, revert to the previous field value
			var fieldValue = mod.prevFieldVal;
			if(mod.selectedIndex !== -1) {
				var selection = mod.results[mod.selectedIndex];
				if('name' in selection) {
					// Display selected suggestion in search field
					fieldValue = selection.name;
				}
			}
			mod.updateQuery(fieldValue);
		},

		previousLiveSearchQuery: null,

		// Triggers a live search
		triggerLiveSearch: function() {
			var mod = this;

			var userQuery = (mod.suggestConfig && mod.suggestConfig.query) || mod.$field.val();
			// If no suggestions present, use the user’s input as query, otherwise use the selected suggestion (or the first, if no suggestion is selected)
			var query = userQuery;
			var suggestion = mod.getSelectedSuggestion() || mod.suggestions[0];
			if(suggestion) {
				query = suggestion.name;
			}

			if(mod.previousLiveSearchQuery === query) {
				// Query hasn’t changed, do nothing
				return;
			}

			mod.previousLiveSearchQuery = query;
			if(mod.liveSearchTimeoutHandle) {
				window.clearTimeout(mod.liveSearchTimeoutHandle);
			}
			// If the user has selected a new suggestion, wait 500ms before loading the results
			// so the user has time to select a different suggestion
			// FIXME: make timeout configurable
			var timeout = 500;
			mod.liveSearchTimeoutHandle = window.setTimeout(function() {
				mod.liveSearchTimeoutHandle = null;
				mod.liveSearchProcessor.process({query: query, userQuery: userQuery});
			}, timeout);

		},

		// Helper function for opening keymatch URLs
		activateKeymatch: function(keymatch) {
			// Store URL so the referenced page knows where we came from
			if ('localStorage' in window) {
				window.localStorage.setItem('sitesearch-keymatch-origin-url', window.location.href);
			}
			// Tracking
			Module.SearchResultContainer.trackClick('keymatch', this.keymatchConfig, keymatch, this.searchProcessor);
		},

		// Click handler for a suggest item
		activateSuggestion: function(suggestion) {
			// Tracking
			Module.SearchResultContainer.trackClick('suggestion', this.suggestConfig, suggestion, this.searchProcessor);
			// Set the form value and let the submit handle the rest
			this.updateQuery(suggestion.name);
			this.$form.submit();
		},

		suggestData: function(processor, data, config) {
			this.suggestConfig = config;
			this.dataChanged(data.results || []);
		},

		keymatchData: function(processor, data, config) {
			this.keymatchConfig = config;
			this.dataChanged(null, config.keymatches || []);
		},

		liveSearchData: function(processor, data, config) {
			this.liveSearchConfig = config;
			this.dataChanged(null, null, data.results||[]);
		},

		dataChanged: function(suggestions, keymatches, liveSearches) {
			var mod = this;
			if(suggestions) {
				this.suggestions = suggestions;
			}
			if(keymatches) {
				// Filter out failed eCommerce calls
				this.keymatches = $.grep(keymatches || [], function(el) {
					return !el.error;
				});
				this.keymatchURLs = {};
				for(var i=0;i<keymatches.length;i+=1) {
					this.keymatchURLs[Module.SearchResultDisplay.normalizeURL(keymatches[i].url)] = true;
				}
			}
			if(liveSearches) {
				this.liveSearches = liveSearches;
			}
			if(suggestions || keymatches) {
				// Reset the selection index.
				// If we don’t do this, the selected suggestion’s name is set in the search box
				// and will override the value just typed by the user.
				mod.selectedIndex = -1;
			}
			mod.results = mod.suggestions.concat(mod.keymatches);
			mod.updateDom();
		},

		selectionChanged: function(delta) {
			var mod = this;
			var newSelectedIndex = mod.selectedIndex + delta;
			if(newSelectedIndex < -1) {
				// On arrow-up, if nothing is selected, select the last item available
				newSelectedIndex = mod.results.length + newSelectedIndex + 1;
			}
			if(newSelectedIndex >= mod.results.length) {
				// On arrow-down at the last item, begin again with being unselected
				newSelectedIndex = -1;
			}
			mod.selectedIndex = newSelectedIndex;
			mod.updateDom();
		}
	});
})(window.Tc.Module, window.Tc.$, window.SCS = window.SCS || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.SiteSearch.js
// module id = 364
// module chunks = 0